class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer =
      this.querySelector('details');

    this.summaryToggle =
      this.querySelector('summary');

    this.closeTimer = null;
    this.openFrame = null;

    this.detailsContainer.addEventListener(
      'keyup',
      (event) =>
        event.code.toUpperCase() ===
          'ESCAPE' && this.close()
    );

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    this.querySelector(
      'button[type="button"]'
    ).addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute(
      'role',
      'button'
    );
  }

  isOpen() {
    return this.detailsContainer.hasAttribute(
      'open'
    );
  }

  onSummaryClick(event) {
    event.preventDefault();

    event.target
      .closest('details')
      .hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains(
        'modal-overlay'
      )
    ) {
      this.close(false);
    }
  }

  cancelPendingMotion() {
    if (this.closeTimer) {
      window.clearTimeout(
        this.closeTimer
      );

      this.closeTimer = null;
    }

    if (this.openFrame) {
      window.cancelAnimationFrame(
        this.openFrame
      );

      this.openFrame = null;
    }
  }

  open(event) {
    this.cancelPendingMotion();

    this.detailsContainer.classList.remove(
      'is-open',
      'is-closing'
    );

    this.detailsContainer.classList.add(
      'is-opening'
    );

    this.onBodyClickEvent =
      this.onBodyClickEvent ||
      this.onBodyClick.bind(this);

    event.target
      .closest('details')
      .setAttribute('open', '');

    document.body.addEventListener(
      'click',
      this.onBodyClickEvent
    );

    if (
      this.classList.contains(
        'header__search'
      )
    ) {
      this.closest(
        '.ns-site-header'
      )?.style.setProperty(
        '--ns-dropdown-glass-height',
        '0px'
      );

      document.documentElement.classList.add(
        'ns-search-open'
      );
    } else {
      document.body.classList.add(
        'overflow-hidden'
      );
    }

    trapFocus(
      this.detailsContainer.querySelector(
        '[tabindex="-1"]'
      ),
      this.detailsContainer.querySelector(
        'input:not([type="hidden"])'
      )
    );

    /*
      Two layout frames create a genuine transition from
      the hidden opening state to the visible state.
    */
    this.openFrame =
      window.requestAnimationFrame(() => {
        this.openFrame =
          window.requestAnimationFrame(() => {
            this.detailsContainer.classList.remove(
              'is-opening'
            );

            this.detailsContainer.classList.add(
              'is-open'
            );

            this.openFrame = null;
          });
      });
  }

  finishClose(focusToggle = true) {
    removeTrapFocus(
      focusToggle
        ? this.summaryToggle
        : null
    );

    if (
      this.classList.contains(
        'header__search'
      )
    ) {
      /*
        Always restore the header first. Predictive-search
        cleanup must never be allowed to leave the header hidden.
      */
      document.documentElement.classList.remove(
        'ns-search-open'
      );

      const predictiveSearch = this.querySelector(
        'predictive-search'
      );

      if (
        typeof predictiveSearch?.close ===
        'function'
      ) {
        try {
          predictiveSearch.close(true, true);
        } catch (error) {
          console.error(
            'Predictive search cleanup failed:',
            error
          );
        }
      }
    }

    this.detailsContainer.removeAttribute(
      'open'
    );

    this.detailsContainer.classList.remove(
      'is-opening',
      'is-open',
      'is-closing'
    );

    document.body.removeEventListener(
      'click',
      this.onBodyClickEvent
    );

    this.closeTimer = null;
  }

  close(focusToggle = true) {
    if (!this.isOpen()) return;

    this.cancelPendingMotion();

    if (
      !this.classList.contains(
        'header__search'
      )
    ) {
      this.finishClose(focusToggle);
      return;
    }

    this.detailsContainer.classList.remove(
      'is-opening',
      'is-open'
    );

    this.detailsContainer.classList.add(
      'is-closing'
    );

    const reduceMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

    /*
      340ms matches the existing header glass height
      transition.
    */
    this.closeTimer =
      window.setTimeout(
        () =>
          this.finishClose(focusToggle),
                reduceMotion ? 0 : 340
      );
  }
}

customElements.define(
  'details-modal',
  DetailsModal
);